<template>
  <v-card>
    <v-card-text class="pa-2" v-if="companyIsLoad && !skipInstructions">
      <v-sheet
        class="text-center mb-1 card-title"
        color="primary"
        elevation="1"
        dark
      >{{$t('instructions.title')}}</v-sheet>
      <v-stepper v-model="instructionStep" alt-labels>
        
        <v-stepper-header>
          <v-stepper-step :complete="instructionStep > 1" :step="1">{{$t('instructions.step')}} 1</v-stepper-step>
          <template v-for="(instruction, index) in companyInstruction">
            <v-divider :key="'generalDidiver_' + index"></v-divider>
            <v-stepper-step
              :key="'headerKey_' + index"
              :complete="instructionStep > (index + 1)"
              :step="index + 2"
            >{{$t('instructions.step')}} {{index + 2}}</v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content :step="1">
            <v-row>
              <v-col cols="12" align="center">
                <v-img
                  eager
                  contain
                  max-height="500px"
                  :src="filesUrl + 'logo/' + supplyPicture"
                ></v-img>
              </v-col>
            </v-row>
            <v-layout>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="instructionStep = 2">{{$t('general.next')}}</v-btn>
            </v-layout>
          </v-stepper-content>

          <v-stepper-content
            v-for="(instruction, index) in companyInstruction"
            :key="'stepperKey_' + index"
            :step="index + 2"
          >
            <v-row>
              <v-col cols="12" align="center">
                <v-img
                  eager
                  contain
                  max-height="500px"
                  :src="filesUrl + 'instructions/' + instruction.img"
                ></v-img>
              </v-col>
            </v-row>
            <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                v-if="instructionStep > 1 &&  instructionStep <= (instructionsCount + 1)"
                text
                color="primary"
                @click="instructionStep = index + 1"
              >{{$t('general.previous')}}</v-btn>
              <v-btn
                v-if="instructionStep <= instructionsCount"
                color="primary"
                @click="instructionStep = index + 3"
              >{{$t('general.next')}}</v-btn>

              <v-btn
                v-if="!companyReady && instructionStep > instructionsCount"
                :loading="companyLoading"
                color="primary"
                @click="selectAvatar"
              >{{$t('instructions.ready')}}</v-btn>

              <v-btn
                v-else-if="instructionStep > instructionsCount"
                color="primary"
                :disabled="!gameReady || companyLoading"
                :loading="companyLoading"
                @click="start"
              >{{ gameReady ? $t('instructions.start') : $t('instructions.wait') }}</v-btn>

            </v-layout>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-card-text>
    <v-card-text v-else>
      <v-row>
        <v-col cols="12" align="center">
          <v-img
            eager
            contain
            max-height="500px"
            :src="filesUrl + 'logo/' + supplyPicture"
          ></v-img>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" >
        <v-col align-self="center" xl="6" md="8" sm="12" >
          <v-btn
          block
            v-if="!companyReady"
            :loading="companyLoading"
            color="primary"
            @click="selectAvatar"
          >{{$t('instructions.ready')}}</v-btn>

          <v-btn
          v-else
            block
            color="primary"
            :disabled="!gameReady || companyLoading"
            :loading="companyLoading"
            @click="start"
          >{{ gameReady ? $t('instructions.start') : $t('instructions.wait') }}</v-btn>

        </v-col>
      </v-row>
    </v-card-text>
    <avatar-selection @cancel="selectAvatarDialog = false" @validation="setReadyLocal" :show="selectAvatarDialog"/>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AvatarSelection from '@/views/AvatarSelection'
export default {
  name: "Instructions",

  props: {
    instruction: Boolean
  },

  components: {
    AvatarSelection
  },

  data: () => ({
    selectAvatarDialog: false
  }),

  mounted () {
    if (this.instructionStep === false) {
      this.instructionStep = 1
    }
  },

  methods: {
    async selectAvatar() {
      this.selectAvatarDialog = true
    },

    async setReadyLocal(avatar) {
      if (await this.setReady(avatar)) {
        this.selectAvatarDialog = false
      }
    },

    async start() {
      await this.startWeek();
    },

    ...mapActions("company", {
      setReady: "setReady",
      startWeek: "startWeek"
    })
  },

  computed: {
    
    instructionStep: {
      get() {
        return this.$store.state.interfaceSettings.instructionStep;
      },
      set(newValue) {
        this.$store.commit("interfaceSettings/SET_instructionStep", newValue);
      }
    },

    instructionsCount() {
      return this.companyInstruction.length
    },

    companyInstruction() {
      return this.instructions.filter(instruction => {
        if (
          this.isProductionCompany &&
          !instruction.factory.includes("factory")
        ) {
          return false;
        }
        if (
          !this.isProductionCompany &&
          !instruction.factory.includes("non-factory")
        ) {
          return false;
        }
        if (this.ddOn && !instruction.dd.includes("dd")) {
          return false;
        }
        if (!this.ddOn && !instruction.dd.includes("non-dd")) {
          return false;
        }
        return true;
      });
    },

    ...mapGetters("company", {
      isProductionCompany: "isProductionCompany",
      companyReady: "ready",
      companyLoading: "loading",
      companyIsLoad: "companyIsLoad",
      supplyPicture: "supplyPicture",
      filesUrl: "filesUrl",
      ddOn: "ddOn"
    }),

    ...mapGetters("game", {
      instructions: "instructions",
      gameReady: "ready",
      skipInstructions: "skipInstructions"
    })
  }
};
</script>

<style>
</style>